import React, { useEffect } from 'react';
import {
  Alert, Image, ScrollView, TextInput, View
} from 'react-native';
import { TextInputMask } from 'react-native-masked-text';
import Icon from 'react-native-vector-icons/Ionicons';
import { useDispatch, useSelector } from 'react-redux';

import logo_purple from '../../../assets/images/logo_purple.png';
import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { CompanyActions } from '../../../redux/reducers/companyReducer';
import { styles } from './styles';

const HirePlans = ({ navigation }) => {
  const dispatch = useDispatch();
  const { companySignUp } = useSelector((state) => state.company);
  const handleContinue = () => {
    if (companySignUp.nome === ''
        || companySignUp.cnpj === ''
        || companySignUp.email === ''
        || companySignUp.telefone === ''
        || companySignUp.contato === '') {
      Alert.alert('Erro', 'Não pode deixar campos em branco');
      return;
    }
    navigation.navigate('Company Plans', { screen: 'Como Funciona: Online' });
  };
  useEffect(() => {
    dispatch({
      type: CompanyActions.UPDATE_SIGNUP,
      companySignUp: {
        ...companySignUp,
        nome: '',
        cnpj: '',
        email: '',
        telefone: '',
        contato: '',
      },
    });
  }, []);
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Cadastro" />
      <ScrollView style={styles.card}>
        <Image style={styles.logo} source={logo_purple} />
        <AppText size="bold" style={styles.textTitle}>Após o cadastro, você será redirecionado para os planos corporativos</AppText>
        <View style={styles.viewForm}>
          <View>
            <TextInput value={companySignUp.nome} onChangeText={(nome) => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, nome } })} placeholder="Nome da Empresa" keyboardType="default" style={styles.input} />
            <Icon name="business-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInputMask value={companySignUp.cnpj} type="cnpj" onChangeText={(cnpj) => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, cnpj } })} placeholder="CNPJ da Empresa" keyboardType="numeric" style={styles.input} />
            <Icon name="business-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInput value={companySignUp.email} onChangeText={(email) => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, email } })} placeholder="E-Mail Corporativo" keyboardType="email-address" style={styles.input} />
            <Icon name="mail-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInputMask type="cel-phone" value={companySignUp.telefone} onChangeText={(telefone) => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, telefone } })} placeholder="Telefone" keyboardType="phone-pad" style={styles.input} />
            <Icon name="call-outline" style={styles.inputIcon} />
          </View>
          <View>
            <TextInput value={companySignUp.contato} onChangeText={(contato) => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, contato } })} placeholder="Nome do Responsável" keyboardType="default" style={styles.input} />
            <Icon name="person-outline" style={styles.inputIcon} />
          </View>
          <AppButton
            size="bold"
            onPress={handleContinue}
            style={styles.button}
            labelStyle={styles.textButton}
            label="Entrar"
          />
        </View>
        {/* <TextInput
            placeholder="Nome da Empresa"
            selectionColor="#3A4594"
            keyboardType="default"
            style={styles.input}
          />

          <TextInput
            placeholder="E-mail Corporativo"
            selectionColor="#3A4594"
            keyboardType="email-address"
            style={Platform.OS !== 'web' ? styles.input : stylesWeb.input}
          />

          <TextInput
            placeholder="Telefone"
            selectionColor="#3A4594"
            keyboardType="phone-pad"
            style={Platform.OS !== 'web' ? styles.input : stylesWeb.input}
          />
          <TextInput
            placeholder="Nome do Responsável"
            selectionColor="#3A4594"
            keyboardType="default"
            style={Platform.OS !== 'web' ? styles.input : stylesWeb.input}
          /> */}

      </ScrollView>
    </>
  );
};

export default HirePlans;
